
import mixin from '../mixins/index'
import CtDate from '@/components/datePicker/index'
import CtSelect from '@/components/select/single-mb.vue'

export default {
  components: {
    CtDate,
    CtSelect,
  },
  mixins: [mixin],
}
